import { Component, OnInit } from '@angular/core';
import { NgForm, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { Subscription } from 'rxjs/Subscription';

import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';

import * as _moment from 'moment';

import {default as _rollupMoment} from 'moment';
import { UpperCasePipe, DatePipe, Location } from '@angular/common';
import { FilterService } from 'src/app/shared/filter.service';
import { AlertmessageService } from 'src/app/shared/alertmessage.service';
import { NotificationService } from 'src/app/notification.service';
import { BackendService } from '../shared/backend.service';
import { AuthService } from '../shared/auth.service';
import { OrderByService } from '../shared/orderby.service';
import { PaginationService } from '../shared/pagination.service';
import CONFIG from '../config';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { PopupdisplayComponent } from '../popupdisplay/popupdisplay.component';

import { Utilities } from '../shared/utility-services.service';
import { ConfirmComponent } from './confirm/confirm.component';





const moment = _rollupMoment || _moment;


@Component({
  selector: 'app-viewimportaudit',
  templateUrl: './viewimportaudit.component.html',
  styleUrls: ['./viewimportaudit.component.scss'],
  providers: [OrderByService,DatePipe,
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
   {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
  ],
})
export class ViewimportauditComponent extends Utilities implements OnInit {
  viewSubmissions: FormGroup;
  DateFilter: FormGroup;
  Filter: FormGroup;
  apiUrl: string = '';
  searchArray: Array<string> = [];
  accountsArray: Array<string> = [];
  securityArray: Array<string> = [];
  submitted: boolean = false;
  fields: string[] = [];
  fieldNames: string[] = [];
  defaultSortOrder: string = '';
  currentSortOrder: string = '';
  exportTitle: string = 'Exported-Data';
  viewsubmissions: any;
  localdataview: any;
  localdataimport:any;
  viewsubmissionsDate: any;
  importauditrecrods: any;
  acctbalance: any;
  bankcodevalue: any;
  bankId: any;
  branchcodes: any;
  bankbranchids: any;
  branchfiltercodes: any;
  branchcodevalue: any;
  accounttype: any;
  currency: any;
  currencies: any;
  orderBy: any;
  status: Array<string>=['Pending','Active','Rejected'];
  accountnumbers: any;
  startdate:any;
  enddate:any;
  griddisplay:boolean=false;
  totalviewsubmissionsEntries: number = 0;
  totalauditrecrodsEntries: number=0 ;
  loadingData: boolean = false;
  pagenlenth: boolean = true;

  entryRangeSubscription: Subscription;
  entryRangeSubscription1: Subscription;
  entryRange: Array<number>;
  auditrecords:any;
  auditrecords1:any;
  totalEntries:any;
  branchessss: Array<string>;
  data:any={};
  currencyvalue:any;
  branchvalue:any;
  accountnumbervalue:any;
  accounttypevalue:any;
  statusvalue:any;
  statusvalue1:any;

  filtereddropdownsauditrecords:any;
  filtereddropdownssubmissionsrecords:any;

  totalfilteredauditrecrodsEntries:any;
  totalfilteredviewsubmissionsEntries:any;
  startDate:any;
  endDate:any;
  active: string = '';
  Displaytrue:any;

  SubIDList:Array<number>[]=[];
  errorinshow:boolean=false;
  Msg:string;
  showgridstate:boolean=false;

  BankId:any;
  constructor(
    public _formBuilder: FormBuilder,
    public backendService: BackendService,
    public authService: AuthService,
    public notificationService: NotificationService,
    public orderByService: OrderByService,
    public paginationService: PaginationService,
    public filterService:FilterService,
    public datePipe:DatePipe,
    public alert:AlertmessageService,
    public router:Router,
    public dialog: MatDialog,
    public location:Location
  )
   {
    super(location, notificationService, authService, backendService);
    this.setForm();
  }

  ngOnInit() {
    this.apiUrl = CONFIG.viewSubmissionApiUrlBase;
    this.searchArray = ['sdate', 'transactionType', 'securityDescription', 'quantity', 'currency', 'settlementAmount'];
    // this.accountsArray = ['accountNumber'];
    this.fields = ['settlementDate', 'transactionType', 'securityDescription', 'quantity', 'currency', 'settlementAmount'];
    this.fieldNames = ['CustomerID', 'SettlementDate', 'TransactionType', 'SecurityDescription', 'SettlementAmount', 'Face', 'Currency', 'Price'];
    this.defaultSortOrder = 'sdate';
   
    this.Filter = this._formBuilder.group({
      // 'Currency': [''],
      'BranchCode': [''],
      // 'AccountNumber': [''],
      // 'AccountType': [''],
      // 'Status': ['']
    });
    this.DateFilter = this._formBuilder.group({
      'enddate': [''],
      'startdate': ['']   
    });  
   
    this.startdate = new FormControl((moment([1900, 0, 1])));
    this.enddate = new FormControl(new Date());
    this.getbankIdDropdown();
     this.getSubmissions();
  }
  addItem(value) {

  }
  getbankIdDropdown() {
    this.backendService.getData(`${CONFIG.getbankIdDropdownApiUrlBase}`)
      .subscribe(response => { console.log(response);
        this.bankId = response['bankid'];
        this.branchcodes = response['branchcodelist'];
        this.bankbranchids = response['bankbranchids'];
                        
      });
    this.backendService.getData(`${CONFIG.getdataentryDropdownsApiUrlBase}`)
      .subscribe(response => {
        this.accounttype = response['accounttype'];
        this.currency = response['currency'];
        this.currencies = response['currencies'];      
      });
  }
  btnDisplay(value)
  {
    console.log(value);
    this.Displaytrue="Display";
  }

  btnDelete(Record)
  {
   // console.log(data);
var Submitted=Record.daPendindACCID;
//console.log(Submitted);
this.openDialog(Record);

    // this.backendService.postData(data,`${CONFIG.viewSubmissionDeleteApiUrlBase}/${Submitted}`)
    // .subscribe(response => {
    //   if (response) {[]
    //     this.setForm();
    //     this.alert.openConfirmationDialogLong1(response['msg']);;
       
    //    // this.getbankIdDropdown();
    //   // this.getSubmissions();
    //   this.loadingData = true;
    //   //this.filterbyStatus();
    //  //this.refresh()
    //   }
    //   else {
    //     this.alert.openConfirmationDialogLong(response['msg']);;
    //     //this.getSubmissions();
    //     this.loadingData = true;
    //    this.refresh()
    //   }

    // });
  }

  openDialog(updatedProfile: any): void {
    //localStorage.setItem('key', key);
    let dialogRef = this.dialog.open(ConfirmComponent, {
        width: '50%',
        height: '25%',
        data:  updatedProfile 
    });
    this.router.navigate(['/dashboard/viewimportaudit']);
    dialogRef.afterClosed().subscribe(result => {
        //this.GetExchangeData();
        //this.serviceInit();
    });
}
 

  getSubmissions() {
    this.loadingData = false;
    if(this.authService.LoginType=="Admin")
    {
      console.log("test")
    // this.backendService.getData(`${this.apiUrl}`)
    //   .subscribe(response => {console.log(response);
    //     this.viewsubmissions = response['viewsubmissions'];
    //     this.importauditrecrods = response['importauditrecrods'];
    //     this.acctbalance = response['acctbalance'];

    //   });
    }
    else
    {
      
      this.backendService.getData(`${this.apiUrl}/${this.authService.TaskNumber}`)
      .subscribe(response => {console.log(response);
        this.accountnumbers = response['accountnumbers'];
        this.viewsubmissions = response['viewsubmissions'];
        this.localdataview=response['viewsubmissions'];

        this.importauditrecrods = response['importauditrecrods'];
        this.localdataimport=response['importauditrecrods'];
        this.acctbalance = response['acctbalance'];
        this.auditrecords=this.importauditrecrods;
        this.loadingData = true;
        this.totalauditrecrodsEntries=this.importauditrecrods.length;

        this.setGrid(1, this.importauditrecrods.length, "search");
        this.entryRangeSubscription = this.paginationService.entryRange
            .subscribe(range => {
                this.entryRange = range;
                console.log("range" + this.entryRange[0], this.entryRange[1]);
                this.auditrecords=this.importauditrecrods.slice(this.entryRange[0], this.entryRange[1]);;
                //this.exportItems = this.datefilteredaudit;
                console.log('this.audit' + this.auditrecords.length);
                this.totalauditrecrodsEntries = this.importauditrecrods.length; 
                console.log(this.importauditrecrods.length); 
                if(this.importauditrecrods==null)
                    this.totalauditrecrodsEntries=0;  
                    else
                            this.totalauditrecrodsEntries=this.importauditrecrods.length;             
            });
          
      });
    }
  }

  filterbyCurrency()
  {
    console.log(this.importauditrecrods);
    this.currencyvalue = this.Filter.controls['Currency'].value;
    this.branchvalue = this.Filter.controls['BranchCode'].value;
    this.accountnumbervalue = this.Filter.controls['AccountNumber'].value;
    this.accounttypevalue = this.Filter.controls['AccountType'].value;
    this.statusvalue = this.Filter.controls['Status'].value;
    console.log(this.currencyvalue, this.branchvalue, this.accountnumbervalue, this.accounttypevalue, this.statusvalue);

    //this.filtereddropdownsauditrecords = this.importauditrecrods.filter(x => x.currencycode == this.currencyvalue && x.branchCode == this.branchvalue && x.accountNo == this.accountnumbervalue && x.accountType == this.accounttypevalue && x.status == this.statusvalue);
   if(this.viewsubmissions==null&&this.authService.LoginType=="Admin")
   {
    this.alert.openConfirmationDialog("Please select BankID.");
   }
   else
   {
    this.filtereddropdownssubmissionsrecords = this.viewsubmissions.filter(x => x.currencycode == this.currencyvalue);
    //|| x.branchCode == this.branchvalue || x.accountNo == this.accountnumbervalue || x.accountType == this.accounttypevalue || x.status == this.statusvalue
   // this.totalfilteredauditrecrodsEntries = this.filtereddropdownsauditrecords.length;
    this.totalfilteredviewsubmissionsEntries = this.filtereddropdownssubmissionsrecords.length;
    console.log(this.filtereddropdownssubmissionsrecords);
    this.auditrecords=this.importauditrecrods;
    
    //this.totalauditrecrodsEntries=this.importauditrecrods.length;
            this.setGrid(1, this.totalfilteredviewsubmissionsEntries, "search");
            this.entryRangeSubscription = this.paginationService.entryRange
                .subscribe(range => {
                    this.entryRange = range;
                    console.log("range" + this.entryRange[0], this.entryRange[1]);
                    this.auditrecords1 = this.filtereddropdownssubmissionsrecords.slice(this.entryRange[0], this.entryRange[1]);
                    //this.exportItems = this.datefilteredaudit;
                    console.log('this.audit' + this.auditrecords1.length);
                    this.totalviewsubmissionsEntries = this.totalfilteredviewsubmissionsEntries; 
                    if(this.importauditrecrods==null)
                    this.totalauditrecrodsEntries=0; 
                    else
                            this.totalauditrecrodsEntries=this.importauditrecrods.length; 

                });
              }
              
  }
  filterbyBranchCode()
  {
    this.branchvalue = this.Filter.controls['BranchCode'].value;
    console.log(this.branchvalue);
    if(this.importauditrecrods==null&&this.authService.LoginType=="Admin")
    {
     this.alert.openConfirmationDialog("Please select BankID.");
    }
    else
    {
    this.filtereddropdownssubmissionsrecords = this.importauditrecrods.filter(x =>  x.branchCode == this.branchvalue );
    this.totalfilteredviewsubmissionsEntries = this.filtereddropdownssubmissionsrecords.length;
    console.log(this.filtereddropdownssubmissionsrecords);
    this.auditrecords=this.importauditrecrods;
    

            this.setGrid(1, this.totalfilteredviewsubmissionsEntries, "search");
            this.entryRangeSubscription = this.paginationService.entryRange
                .subscribe(range => {
                    this.entryRange = range;
                    console.log("range" + this.entryRange[0], this.entryRange[1]);
                    this.auditrecords = this.filtereddropdownssubmissionsrecords.slice(this.entryRange[0], this.entryRange[1]);
                    //this.exportItems = this.datefilteredaudit;
                    console.log('this.audit' + this.auditrecords.length);
                    this.totalviewsubmissionsEntries = this.totalfilteredviewsubmissionsEntries;
                    if(this.importauditrecrods==null)
                    this.totalauditrecrodsEntries=0;
                    else
                            this.totalauditrecrodsEntries=this.importauditrecrods.length;                
                });
              }
  }
  filterbyAccountNumber()
  {
    this.accountnumbervalue = this.Filter.controls['AccountNumber'].value;
    if(this.viewsubmissions==null&&this.authService.LoginType=="Admin")
    {
     this.alert.openConfirmationDialog("Please select BankID.");
    }
    else
    {
    this.filtereddropdownssubmissionsrecords = this.viewsubmissions.filter(x =>  x.accountNo == this.accountnumbervalue );
    this.totalfilteredviewsubmissionsEntries = this.filtereddropdownssubmissionsrecords.length;
    console.log(this.filtereddropdownssubmissionsrecords);
    this.auditrecords=this.importauditrecrods;
    //this.totalauditrecrodsEntries=this.importauditrecrods.length;

            this.setGrid(1, this.totalfilteredviewsubmissionsEntries, "search");
            this.entryRangeSubscription = this.paginationService.entryRange
                .subscribe(range => {
                    this.entryRange = range;
                    console.log("range" + this.entryRange[0], this.entryRange[1]);
                    this.auditrecords1 = this.filtereddropdownssubmissionsrecords.slice(this.entryRange[0], this.entryRange[1]);
                    //this.exportItems = this.datefilteredaudit;
                    console.log('this.audit' + this.auditrecords1.length);
                    this.totalviewsubmissionsEntries = this.totalfilteredviewsubmissionsEntries;
                    if(this.importauditrecrods==null)
                    this.totalauditrecrodsEntries=0; 
                    else
                            this.totalauditrecrodsEntries=this.importauditrecrods.length;                   
                });
              }
  }
  filterbyAccountType()
  {
    this.accounttypevalue = this.Filter.controls['AccountType'].value;
    console.log(this.accounttypevalue);
    if(this.viewsubmissions==null&&this.authService.LoginType=="Admin")
    {
     this.alert.openConfirmationDialog("Please select BankID.");
    }
    else
    {
    this.filtereddropdownssubmissionsrecords = this.viewsubmissions.filter(x =>  x.accountType == this.accounttypevalue );
    this.totalfilteredviewsubmissionsEntries = this.filtereddropdownssubmissionsrecords.length;
    console.log(this.filtereddropdownssubmissionsrecords);
    this.auditrecords=this.importauditrecrods;
    //this.totalauditrecrodsEntries=this.importauditrecrods.length;

            this.setGrid(1, this.totalfilteredviewsubmissionsEntries, "search");
            this.entryRangeSubscription = this.paginationService.entryRange
                .subscribe(range => {
                    this.entryRange = range;
                    console.log("range" + this.entryRange[0], this.entryRange[1]);
                    this.auditrecords1 = this.filtereddropdownssubmissionsrecords.slice(this.entryRange[0], this.entryRange[1]);
                    //this.exportItems = this.datefilteredaudit;
                    console.log('this.audit' + this.auditrecords1.length);
                    this.totalviewsubmissionsEntries = this.totalfilteredviewsubmissionsEntries;                
                    if(this.importauditrecrods==null)
                    this.totalauditrecrodsEntries=0; 
                    else
                            this.totalauditrecrodsEntries=this.importauditrecrods.length;   
                });
              }
  }
  filterbyStatus()
  {
    this.statusvalue = this.Filter.controls['Status'].value;
    this.statusvalue1=this.statusvalue.toUpperCase();
    console.log(this.statusvalue.toUpperCase());
    if(this.viewsubmissions==null&&this.authService.LoginType=="Admin")
    {
     this.alert.openConfirmationDialog("Please select BankID.");
    }
    else
    {
    this.filtereddropdownssubmissionsrecords = this.viewsubmissions.filter(x =>  x.status == this.statusvalue||x.status == this.statusvalue1  );
    this.totalfilteredviewsubmissionsEntries = this.filtereddropdownssubmissionsrecords.length;
    console.log(this.filtereddropdownssubmissionsrecords);
    this.auditrecords=this.importauditrecrods;
    //this.totalauditrecrodsEntries=this.importauditrecrods.length;

            this.setGrid(1, this.totalfilteredviewsubmissionsEntries, "search");
            this.entryRangeSubscription = this.paginationService.entryRange
                .subscribe(range => {
                    this.entryRange = range;
                    console.log("range" + this.entryRange[0], this.entryRange[1]);
                    this.auditrecords1 = this.filtereddropdownssubmissionsrecords.slice(this.entryRange[0], this.entryRange[1]);
                    //this.exportItems = this.datefilteredaudit;
                    console.log('this.audit' + this.auditrecords1.length);
                    this.totalviewsubmissionsEntries = this.totalfilteredviewsubmissionsEntries;
                    if(this.importauditrecrods==null)
                      this.totalauditrecrodsEntries=0;
                    else
                      this.totalauditrecrodsEntries=this.importauditrecrods.length;                    
                });
              }
  }
  FilterBySearch()
  {
    //this.currencyvalue = this.Filter.controls['Currency'].value;
    this.branchvalue = this.Filter.controls['BranchCode'].value;
    // this.accountnumbervalue = this.Filter.controls['AccountNumber'].value;
    // this.accounttypevalue = this.Filter.controls['AccountType'].value;
    // this.statusvalue = this.Filter.controls['Status'].value;
    // this.statusvalue1=this.statusvalue.toUpperCase();
    console.log(this.statusvalue );
    if(this.authService.LoginType=="Admin")
    {
      this.bankcodevalue = this.viewSubmissions.controls['BankCode'].value;
    }
    else
    {
      this.bankcodevalue =this.authService.TaskNumber;
    }
    this.data.Currency=this.currencyvalue;
    this.data.Branch=this.branchvalue;
    this.data.AccountNumber=this.accountnumbervalue;
    this.data.AccountType=this.accounttypevalue;
    this.data.Status=this.statusvalue;
    this.backendService.postData(this.data,`${this.apiUrl}/${this.bankcodevalue}`)
                  .subscribe(response => {
                    console.log(response);
                    //this.viewsubmissions = response['viewsubmissions'];  
                    this.importauditrecrods = response['importauditrecrods'];
                    this.auditrecords=this.importauditrecrods;
                    
                    this.setGrid(1, this.importauditrecrods.length, "search");
                    this.entryRangeSubscription = this.paginationService.entryRange
                        .subscribe(range => {
                            this.entryRange = range;
                            console.log("range" + this.entryRange[0], this.entryRange[1]);
                            this.auditrecords1 = this.importauditrecrods.slice(this.entryRange[0], this.entryRange[1]);
                            //this.exportItems = this.datefilteredaudit;
                            console.log('this.audit' + this.auditrecords1.length);
                            this.totalviewsubmissionsEntries = this.importauditrecrods.length;
                            if(this.importauditrecrods==null)
                            this.totalauditrecrodsEntries=0;
                            else
                            this.totalauditrecrodsEntries=this.importauditrecrods.length;          
                        });
    })
    // &&
    //   x.accountNo == this.accountnumbervalue && x.accountType == this.accounttypevalue && x.status == this.statusvalue && x.status == this.statusvalue1
   
    // this.filtereddropdownssubmissionsrecords = this.localdataview.filter(x =>x.currencycode == this.currencyvalue && x.branchCode == this.branchvalue   );
    // this.totalfilteredviewsubmissionsEntries = this.filtereddropdownssubmissionsrecords.length;
    // console.log(this.filtereddropdownssubmissionsrecords);
   
}
  makeActive(item) {
    this.active = this.active === item ? '' : item;
}
  refresh()
  {
   this.setForm();
   //this.loadingData = true;
    // this.viewsubmissions=[];
    // this.importauditrecrods=[];
      // this.auditrecords1=this.viewsubmissions;
      // this.auditrecords=this.importauditrecrods;
      this.getSubmissions();
    console.log("test");
  }
  filterbystartDate(date)
  {
    this.startDate = this.datePipe.transform(date,"MM/dd/yyyy");
    if(this.endDate==undefined)
    {
      this.endDate=this.datePipe.transform(new Date(),"MM/dd/yyyy");
      //this.dateFilter(this.endDate,this.startDate );
    }
   
      this.dateFilter(this.endDate,this.startDate );
    
  }
  filterbyDate(date)
  {
    console.log(this.endDate,this.startDate);
    console.log(date);
    //this.startDate = this.DateFilter.controls['startdate'].value;
    this.endDate = this.datePipe.transform(date,"MM/dd/yyyy");
    console.log(this.endDate);
   
   
    if(this.startDate==undefined)
    {
      this.startDate=this.datePipe.transform("1/1/1990");
    }
    // else
    // {
      this.dateFilter(this.endDate,this.startDate );
    // }
  

  }
  dateFilter(edate, sdate) {

    // console.log(edate, sdate);
    //this.viewsubmissionsDate = this.viewsubmissions;
    //console.log(this.datefilteroriginalitems);

    let startInclude: any = '';
    let endInclude: any = '';

    startInclude = new Date(sdate);
    endInclude = new Date(edate);
console.log(edate, sdate,startInclude,endInclude);
    let submit = {
      'startdate': startInclude,
      'enddate': endInclude
    }
console.log(submit);
    //convert any date field values to Date type (so filter function can find proper property name)
    this.viewsubmissions.forEach(entry => {
      //entry['sdate'] = new Date(entry['sdate']);
      entry['lastTransDate'] = new Date(entry['lastTransDate']);
    });
    this.importauditrecrods.forEach(entry => {
      //entry['sdate'] = new Date(entry['sdate']);
      entry['importDate'] = new Date(entry['importDate']);
    });
    this.filtereddropdownsauditrecords = this.filterService.filterFromMultiple(submit, this.importauditrecrods);
    //this.auditrecords = this.filtereddropdownsauditrecords;
    
    //perform the filter, assign it to main audit variable
    //this.filtereddropdownssubmissionsrecords = this.filterService.filterFromMultiple(submit, this.viewsubmissionsDate);
    //this.datefilteredaudit = this.filterService.filterFromMultiple(submit, this.datefilteroriginalitems);
    //console.log(this.auditrecords1);
    this.setGrid(1, this.filtereddropdownsauditrecords.length, "search");
            this.entryRangeSubscription = this.paginationService.entryRange
                .subscribe(range => {
                    this.entryRange = range;
                    console.log("range" + this.entryRange[0], this.entryRange[1]);
                    this.auditrecords = this.filtereddropdownsauditrecords.slice(this.entryRange[0], this.entryRange[1]);
                    //this.exportItems = this.datefilteredaudit;
                    console.log('this.audit' + this.auditrecords.length);
                   // this.totalviewsubmissionsEntries = this.filtereddropdownsauditrecords.length; 
                    this.totalviewsubmissionsEntries = this.auditrecords.length;
                            if(this.importauditrecrods==null)
                            this.totalauditrecrodsEntries=0;
                            else
                            this.totalauditrecrodsEntries=this.auditrecords.length;                       
                });
    // this.totalEntries = this.audit.length;
    // //this.loadingData = true;
    // this.pagenlenth = false;
    // this.setGrid(1, this.audit.length, "search");
    // this.entryRangeSubscription = this.paginationService.entryRange
    //   .subscribe(range => {
    //     this.entryRange = range;
    //     if (1 <= 0) {
    //       if (this.audit.length == 0) {
    //         this.audit = this.originalItems;
    //       }
    //       console.log('!!!!!');
    //       this.audit = this.originalItems.slice(this.entryRange[0], this.entryRange[1]);
    //       this.exportItems = this.originalItems;
    //       this.totalEntries = this.originalItems.length;

    //     } else {
    //       console.log(this.datefilteredaudit);
    //       this.audit = this.datefilteredaudit.slice(this.entryRange[0], this.entryRange[1]);
    //       this.exportItems = this.datefilteredaudit;
    //       this.totalEntries = this.datefilteredaudit.length;
    //     }
    //   });
  }


  filterBankCode() {
    this.loadingData = false;
    this.bankcodevalue = this.viewSubmissions.controls['BankCode'].value;
    console.log(this.bankcodevalue);
    localStorage.setItem('bankcodevalue',this.bankcodevalue );
    this.authService.bankcodevalue=localStorage.getItem('bankcodevalue');
    this.filterBranchCode();
    this.backendService.getData(`${this.apiUrl}/${this.bankcodevalue}`)
      .subscribe(response => {
        console.log(response);
        this.accountnumbers = response['accountnumbers'];
        this.viewsubmissions = response['viewsubmissions'];
        this.importauditrecrods = response['importauditrecrods'];
        this.acctbalance = response['acctbalance'];

        this.pagenlenth = true;
        this.loadingData = true;
        this.totalviewsubmissionsEntries = this.importauditrecrods.length;
        if(this.importauditrecrods==null)
        this.totalauditrecrodsEntries = 0;
        this.auditrecords=this.importauditrecrods;
        console.log(this.totalauditrecrodsEntries,this.totalviewsubmissionsEntries);
        // this.setGrid(1, this.totalauditrecrodsEntries, "search");

        // this.entryRangeSubscription = this.paginationService.entryRange
        //     .subscribe(range => {
        //         this.entryRange = range;
        //         console.log("range" + this.entryRange[0], this.entryRange[1]);
        //         this.auditrecords = this.importauditrecrods.slice(this.entryRange[0], this.entryRange[1]);
        //         //this.exportItems = this.datefilteredaudit;
        //         console.log('this.audit' + this.auditrecords.length);
        //         this.totalauditrecrodsEntries = this.importauditrecrods.length;                
        //     });

        this.setGrid(1, this.totalviewsubmissionsEntries, "search");
        this.entryRangeSubscription1 = this.paginationService.entryRange
            .subscribe(range => {
                this.entryRange = range;
                console.log("range" + this.entryRange[0], this.entryRange[1]);
                this.auditrecords = this.importauditrecrods.slice(this.entryRange[0], this.entryRange[1]);
                //this.exportItems = this.datefilteredaudit;
                console.log('this.audit' + this.auditrecords.length);
                this.totalviewsubmissionsEntries = this.importauditrecrods.length;  
                            if(this.importauditrecrods==null)
                            this.totalauditrecrodsEntries=0;
                            else
                            this.totalauditrecrodsEntries=this.importauditrecrods.length;               
            });

        console.log(this.accountnumbers, this.totalauditrecrodsEntries);
      });
      
  }

  setGrid(start: number, length?: number, value?: string) {
    console.log(length);
    const sentLen = length;
    this.pagenlenth = false;

    this.paginationService.setGrid(start, sentLen);
}
setGrid1(start: number, length?: number, value?: string) {
  console.log(length);
  const sentLen = length;
  this.pagenlenth = false;

  this.paginationService.setGrid1(start, sentLen);
}

filterBranchCode() {
   
  let myArray = [];
  this.bankcodevalue = this.viewSubmissions.controls['BankCode'].value;
  console.log( this.bankcodevalue);
  this.branchfiltercodes = this.bankbranchids.filter(x => x.bankCode == this.bankcodevalue);
  for (var i = 0; i < this.branchfiltercodes.length; i++) {
    this.branchessss = this.branchfiltercodes[i]['branchCode'];
    myArray.push(this.branchessss);
    console.log(myArray);
   
 }
 this.branchcodes = myArray;
//  this.submission = true;
//  this.submissionrecords = this.submissionrecords;

}
  setForm() {

    this.Filter = this._formBuilder.group({
      'Currency': [''],
      'BranchCode': [''],
      'AccountNumber': [''],
      'AccountType': [''],
      'Status': ['']
    });

    this.viewSubmissions = this._formBuilder.group({
      'BankCode': [''],
      //'BranchCode': [''],
      'startdate': [''],
      'enddate': ['']
    });
    this.DateFilter = this._formBuilder.group({
      'startdate': [''],
      'enddate': ['']
    });

  }
  DownloadFile(value)
  {
    console.log(value);
    localStorage.setItem('TransactionNo',value);
    this.authService.TransactionNo=localStorage.getItem('TransactionNo');
    this.router.navigate(['/dashboard/Documents']);
  }
  CheckValue(value,event) 
  {
    console.log(value,event);
    if(event.checked==true)
    this.SubIDList.push(value);
    else
    {
      const index: number = this.SubIDList.indexOf(value);
      this.SubIDList.splice(index,1);
    }

    console.log(this.SubIDList);
   
  }
  showDetails(localData?:any)
   {
     if(this.authService.LoginType=='Admin')
     {
       this.BankId=this.bankcodevalue;
     }
     else
     {
      this.BankId=this.authService.TaskNumber;
     }
   localData={};
    console.log(this.SubIDList);
    localData.subIDList=this.SubIDList;
    console.log(localData);
    this.backendService.putData(localData,`${CONFIG.viewWithDrawalsDeposit}/${this.BankId}`)
    .subscribe(response=>{console.log(response);
    if(response['result'])
    {
      this.showgridstate=true;
      this.errorinshow=false;
    // this.formateDataofGrid(response['showgrid']);
    
    this.viewsubmissions=response['viewsubmissions'];
    }
    else
    {
     this.errorinshow=true;
     this.Msg=response['msg'];
    }
    });
   
   }
   hideDetails()
   {
    this.showgridstate=false;
   }
}
